export enum NotificationI18nType {
    Default = 'default',
    TextWithLink = 'textWithLink',
}
